import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-modal-info',
    templateUrl: './modal-info.component.html',
    styleUrls: ['./modal-info.component.scss'],
    standalone: false
})
export class ModalInfoComponent {
  @Input() public iconSrc: string;
  @Input() public title: string;
  @Input() public text: string;
  @Input() public color: string;
  @Input() public isQuestion: boolean;
  @Input() public overlayTop: boolean;
  @Input() public iconClass: string;
  @Output() confirmEvent = new EventEmitter<boolean>(false); 
  @Output() dissmisModalEvent = new EventEmitter<boolean>(false); 
  @Input() modalRef: any;
  @Input() disableDeleteConfirmButton: boolean = false;
  closeResult = '';

  constructor(private readonly modalService: NgbModal) { }

  open(content) {
    this.modalRef = this.modalService.open(content, {ariaLabelledBy: 'modal-basic', backdrop: 'static', backdropClass: this.color === 'red' || this.overlayTop ? 'delete-modal-backdrop' : '', keyboard: false});
  }

  close() {
    this.modalRef.dismiss();
    this.dissmisModalEvent.emit(true);
  }

  confirm() {
    this.confirmEvent.emit(true);
    this.modalRef.dismiss();
  }

}
